export default [
  {
    path: '/login',
    component: () => import('@/views/Login.vue')
  },
  {
    path: '/',
    component: () => import('@/views/Layout.vue'),
    meta: { auth: true },
    children: [
      {
        path: '',
        component: () => import('@/views/Index.vue'),
        name: 'index',
        meta: { description: '我的面板' }
      },
      {
        path: '/journals',
        component: () => import('@/views/journal/index.vue'),
        name: 'journals',
        meta: { description: '杂志管理' }
      },
      {
        path: '/journals/create',
        component: () => import('@/views/journal/createUpdate.vue'),
        name: 'journalsCreate',
        meta: { description: '新增杂志' }
      },
      {
        path: '/journals/:id/edit',
        component: () => import('@/views/journal/createUpdate.vue'),
        name: 'journalsUpdate',
        meta: { description: '编辑杂志' }
      },
      {
        path: '/journal/danmus',
        component: () => import('@/views/danmus/index.vue'),
        name: 'journalDanmus',
        meta: { description: '弹幕管理' }
      },
      {
        path: '/journal/comments',
        component: () => import('@/views/comments/index.vue'),
        name: 'journalComments',
        meta: { description: '评论管理' }
      },
      {
        path: '/orders',
        component: () => import('@/views/order/index.vue'),
        name: 'orders',
        meta: { description: '订单管理' }
      },
      {
        path: '/adverts',
        component: () => import('@/views/advert/index.vue'),
        name: 'adverts',
        meta: { description: '广告管理' }
      },
      {
        path: '/adverts/create',
        component: () => import('@/views/advert/createUpdate.vue'),
        name: 'advertsCreate',
        meta: { description: '新增广告' }
      },
      {
        path: '/adverts/:id/edit',
        component: () => import('@/views/advert/createUpdate.vue'),
        name: 'advertsUpdate',
        meta: { description: '编辑广告' }
      },
      {
        path: '/users',
        component: () => import('@/views/user/index.vue'),
        name: 'users',
        meta: { description: '用户管理' }
      },
      {
        path: '/resetPassword',
        component: () => import('@/views/admin/resetPassword.vue'),
        name: 'resetPassword',
        meta: { description: '修改密码' }
      },
      {
        path: '/settings',
        component: () => import('@/views/setting/index.vue'),
        name: 'settings',
        meta: { description: '系统设置' }
      }
    ]
  },
  {
    path: '*',
    component: () => import('@/views/404.vue')
  }
]



// WEBPACK FOOTER //
// ./src/router/routes.js